import React from "react";
import { Box, HorizontalScroller } from "../components";
export const BorderedTabsWrapper = ({ children, hideScrollButtons, }) => {
    return (React.createElement(Box, { sx: {
            border: 1,
            borderColor: (theme) => theme.palette.stroke[100],
            borderRadius: (theme) => theme.radius.default,
            padding: 1,
            minWidth: 0,
        } },
        React.createElement(HorizontalScroller, { hideScrollButtons: hideScrollButtons }, children)));
};
//# sourceMappingURL=BorderedTabsWrapper.js.map